import { render, staticRenderFns } from "./UpdateTableSidebar.vue?vue&type=template&id=28059b29&scoped=true&"
import script from "./UpdateTableSidebar.vue?vue&type=script&lang=ts&"
export * from "./UpdateTableSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateTableSidebar.vue?vue&type=style&index=0&id=28059b29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28059b29",
  null
  
)

export default component.exports